export const PAYMENT_SUCCESS = "success";
export const PAYMENT_PENDING = "pending";
export const PAYMENT_FAILURE = "failure";
